import { Turbo } from "@hotwired/turbo-rails"
import "../controllers"
import { navegarCompletoSiFaltaElFrame } from "lib/navegacion_completa_sin_frame"

Turbo.session.drive = false

document.addEventListener('turbo:frame-missing', (event) => navegarCompletoSiFaltaElFrame(event))

// Forms inside turbo-frames are intercepted by Turbo Frame. Mark them as
// data-turbo="false" during capture phase so they submit normally.
document.addEventListener('submit', function(event) {
  const form = event.target
  if (form.closest('turbo-frame') && !form.hasAttribute('data-turbo')) {
    form.setAttribute('data-turbo', 'false')
  }
}, true)

// Ancla (#respuesta_X) del último enlace clicado, pendiente de aplicar cuando el
// frame `content` termine de cargar. Turbo descarta el fragmento al fijar el
// `src` del frame, así que NO se puede recuperar en `turbo:frame-load`; hay que
// capturarlo aquí, en `turbo:click`, donde el href aún lo conserva.
let anclaPendiente = null

document.addEventListener('turbo:click', (event) => {
  const href = event.target.getAttribute('href')

  // Links de /redirections/ hacen 302 a URLs externas → Turbo falla con CORS.
  // Forzar navegación normal del browser para que el 302 funcione. El href ya trae el testigo
  // del clic atestiguado: `clic_atestiguado_controller.js` lo pone antes, en fase de captura.
  if (href && href.includes('/redirections/')) {
    event.preventDefault()
    window.location.href = href
    return
  }

  // Se resetea en CADA click: un enlace sin ancla limpia el ancla del anterior.
  anclaPendiente = href && href.includes('#') ? new URL(href, window.location.origin).hash : null

  event.preventDefault()

  Turbo.session.adapter.progressBar.setValue(0)
  Turbo.session.adapter.progressBar.show()
})

document.addEventListener('turbo:frame-load', (event) => {
  if (event.target.id !== 'content') return

  // Si el enlace clicado traía un ancla (#respuesta_X), hacemos scroll a ese
  // elemento SIN recargar la página. Antes se forzaba `window.location.href`
  // (recarga completa) leyendo `Turbo.session.navigator.__proto__.url`, un hack
  // sobre los internals de Turbo que se rompía en silencio en cada subida de
  // versión. El hash viene percent-encoded; lo decodificamos para obtener el id
  // real del DOM (p.ej. anclas con tildes). Usamos getElementById en vez de
  // querySelector porque acepta cualquier id (incluidos numéricos) sin lanzar
  // SyntaxError.
  const hash = anclaPendiente
  anclaPendiente = null
  const id = hash && hash.length > 1 ? decodeURIComponent(hash).slice(1) : null
  const target = id && document.getElementById(id)

  if (target) {
    target.scrollIntoView()
  } else {
    window.scrollTo(0, 0)
  }
})


// Protección de borradores de respuesta en el foro.
//
// Antes (https://trello.com/c/Eh0xtG4g) había un interceptor que forzaba
// `window.location.href` para TODOS los enlaces `/foros/bolsa/temas/` y, para
// hacerlo, parcheaba temporalmente `window.addEventListener` ignorando los
// listeners de `popstate`/`beforeunload`. Ese parche era frágil: provocaba saltos
// de historial ("ir hacia atrás" mientras se escribía) y, al recargar la página
// entera, destruía el borrador que el usuario tuviera a medio escribir.
//
// Turbo Frame ya navega correctamente esos enlaces (`data-turbo-frame="content"`),
// así que el interceptor se elimina. En su lugar, lo único que protegemos es el
// borrador: si hay una respuesta a medio escribir y el usuario hace clic en un
// enlace que le sacaría del hilo, pedimos confirmación antes de navegar.
function borradorRespuestaSinEnviar() {
  const caja = document.getElementById('thread-new-reply')
  if (!caja) return false

  const editor = caja.querySelector('trix-editor')
  if (editor && editor.editor && editor.editor.getDocument().toString().trim().length > 0) return true

  const titulo = caja.querySelector('input[name*="titulo"]')
  return !!(titulo && titulo.value.trim().length > 0)
}

document.addEventListener('click', function(event) {
  // No interferir con clics modificados (abrir en pestaña nueva), botón no primario,
  // ni con clics ya gestionados por otro handler.
  if (event.defaultPrevented) return
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

  const link = event.target.closest('a[href]')
  if (!link || link.target === '_blank') return

  // Solo preguntamos para enlaces que sacan del hilo: navegación completa o el
  // frame principal `content`. Enlaces a otros turbo-frames (votar, citar, modales)
  // no descartan el borrador, así que no molestamos.
  const turboFrame = link.getAttribute('data-turbo-frame')
  if (turboFrame && turboFrame !== 'content' && turboFrame !== '_top') return

  // Anclas dentro del mismo hilo (saltar a un mensaje) no pierden el borrador.
  if (link.getAttribute('href').startsWith('#')) return

  if (!borradorRespuestaSinEnviar()) return

  if (!window.confirm('Tienes una respuesta sin enviar. Si sales del hilo la perderás. ¿Salir igualmente?')) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }
}, true) // Fase de captura: decidir antes de que Turbo procese el enlace.
